export const theme = {
  palette: {
    primary: {
      main: '#343642',
    },
    secondary: {
      main: '#d7d7d7',
    },
    warning: {
      main: '#FFEC00',
    },
    success: {
      main: '#7FC743',
    },
    error: {
      main: '#FF0000',
    },
  },
};

export default theme;
